import { BRANCHES, MACHINES } from "../data/constants";
import { getAssignedElsewhere } from "../utils/machines";


export default function BranchMachineAssign({ branches, branchMachines, onChange, branchOfficesData }) {
  const toggleMachine = (branchId, machineId) => {
    console.log(machineId);
    const current = branchMachines[branchId] || [];
    const has = current.includes(machineId);
    const updated = { ...branchMachines };

    if (has) updated[branchId] = current.filter((x) => x !== machineId);
    else updated[branchId] = [...current, machineId];

    console.log("Dta actualizada", updated);

    onChange(updated);
  };

  return (
    <div>
      {branches.map((bId) => {
        const branch = branchOfficesData.find((b) => b.id === bId);
        if (!branch) return null;

        const assigned = branchMachines[bId] || [];
        const takenElsewhere = getAssignedElsewhere(branchMachines, bId);

        return (
          <div key={bId} className="ec-assign-section">
            <div className="ec-assign-header" style={{ background: branch.color + "0A" }}>
              <div className="ec-assign-header-icon" style={{ background: branch.color + "18", color: branch.color }}>
                {branch.icon}
              </div>
              <span className="ec-assign-header-name" style={{ color: branch.color }}>{branch.name}</span>
              <span className="ec-assign-header-hint">
                {assigned.length === 0 ? "Sin máquinas" : `${assigned.length} asignada${assigned.length > 1 ? "s" : ""}`}
              </span>
            </div>

            <div className="ec-assign-machines">
              {branch?.machines.map((m) => {
                const isAssigned = assigned.includes(m.id);
                const isTaken = takenElsewhere.has(m.id);

                return (
                  <>
                    {m.type === "Smart pos" || m.type === "Smart Pay" ?
                      <button
                        key={m.id}
                        onClick={() => { if (!isTaken || isAssigned) toggleMachine(bId, m.id); }}
                        className={`ec-assign-chip${isTaken && !isAssigned ? " ec-assign-chip--taken" : ""}`}
                        style={isAssigned ? { borderColor: m.color, background: m.color + "14", color: m.color } : {}}
                        title={isTaken && !isAssigned ? "Ya asignada a otra sucursal" : ""}
                      >
                        {m.name}{isAssigned && " ✓"}
                      </button> : <></>}</>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
